
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'

import { SeCardComponent } from './card.component'

@NgModule({
  imports: [
	CommonModule
  ],
  declarations: [
    SeCardComponent
  ],
  exports: [
    SeCardComponent
  ]
})
export class SeCardModule { }

export const SE_CARD_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.card`

